export default __webpack_public_path__ + "static/media/header.ac060803.jpg";